<template>
    <div class="RwvContentEmbedEdit">
      <b-form-group
        :id="'input-group-title-' + index"
        :label-for="'input-title-' + index"
        v-b-tooltip.hover
        title="Seitenverhältnis">

        <b-form-input
          :id="'input-title-' + index"
          v-model="data.title"
          required
          placeholder="16by9">
        </b-form-input>
      </b-form-group>

      <b-form-group
        :id="'input-group-variant-' + index"
        :label-for="'input-variant-' + index"
        v-b-tooltip.hover
        title="Die Quelle als Link">

        <b-form-input
          :id="'input-embed-src-' + index"
          v-model="data.src"
          required
          placeholder="Quelle">
        </b-form-input>

        <p class="text-muted small">
          Hier den Link, der eingebunden werden soll. <br>
          Bsp.: https://www.youtube.com/embed/zpOULjyy-n8?rel=0
        </p>
      </b-form-group>
    </div>
</template>

<script>
export default {
  name:"RwvContentEmbedEdit",
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  watch: {
    data(data) {
      this.$emit("changed", data)
    }
  }
}
</script>
